<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="课程名称">
        <el-input v-model="form.name" class="input" placeholder="请输入需要查询的课程名称" />
      </el-form-item>
      <div>
        <el-button @click="fetchData">查询</el-button>
        <el-button @click="showAddDialog">新增</el-button>
      </div>
    </el-form>
    <el-table
      ref="table"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="48"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
    >
      <el-table-column align="center" label="课程名称" min-width="180" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="描述" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.description }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.createTime }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="280" fixed="right">
        <template slot-scope="scope">
          <el-button @click="uploadFile(scope.row.id)">文件</el-button>
          <el-button @click="showEditDialog(scope.row)">修改</el-button>
          <el-button @click="delItem(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :pager-count="15"
      :total="totalNum"
      @current-change="handleCurrentChange"
    />
    <el-dialog :title="addForm.id ? '修改课程' : '新增课程'" :visible.sync="addDialogVisible" width="600px" top="15%">
      <div style="width: 100%;">
        <div style="margin-bottom: 20px;">
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">课程名称</label>
          <el-input v-model="addForm.name" placeholder="请输入课程名称" style="width: 100%;" />
        </div>
        <div style="margin-bottom: 20px;">
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">课程描述</label>
          <el-input v-model="addForm.description" type="textarea" placeholder="请输入课程描述" style="width: 100%;" :rows="4" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAdd">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { queryKnowledge, knowledgeDel, courseAdd, courseUpd } from '@/api/knowledgeUpload'

export default {
  data() {
    return {
      list: null,
      listLoading: false,
      form: {
        name: ''
      },
      page: 1,
      totalNum: 0,
      addDialogVisible: false,
      addForm: {
        id: 0,
        name: '',
        description: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleCurrentChange(page) {
      console.log('page', page)
      this.page = page
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const params = {
        'page': this.page,
        'pageSize': 10,
        'name': this.form.name
      }
      await queryKnowledge(params).then(response => {
        this.totalNum = response.data.totalRow
        this.list = response.data.records
        this.$nextTick(() => {
          const tableBodyWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
          if (tableBodyWrapper) {
            tableBodyWrapper.scrollTo({
              top: 0
            })
          }
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    showAddDialog() {
      this.addForm = {
        id: 0,
        name: '',
        description: ''
      }
      this.addDialogVisible = true
    },
    showEditDialog(row) {
      this.addForm = {
        id: row.id,
        name: row.name,
        description: row.description
      }
      this.addDialogVisible = true
    },
    async confirmAdd() {
      if (!this.addForm.name) {
        this.$message({
          message: '请输入课程名称',
          type: 'error',
          duration: 2 * 1000
        })
        return
      }
      try {
        const params = {
          name: this.addForm.name,
          description: this.addForm.description
        }
        if (this.addForm.id) {
          params.id = this.addForm.id
          await courseUpd(params)
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 2 * 1000
          })
        } else {
          await courseAdd(params)
          this.$message({
            message: '新增成功',
            type: 'success',
            duration: 2 * 1000
          })
        }
        this.addDialogVisible = false
        this.fetchData()
      } catch (error) {
        this.$message({
          message: error.message || '操作失败',
          type: 'error',
          duration: 2 * 1000
        })
      }
    },
    uploadFile(courseId) {
      this.$router.push({ name: 'uploadKnowledge', query: { courseId } })
    },
    delItem(id) {
      this.$confirm('此操作将删除该课程, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        knowledgeDel({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
            duration: 2 * 1000
          })
          this.fetchData()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-form{
    display: flex;
    justify-content: space-between;
    /* margin-bottom: 20px; */
  }
  .el-table{
    overflow: auto;
  }
  .el-form-item__content{
    display: flex;
    position: relative;
  }
  .el-button {
    margin-left: 0;
    padding: 10px 18px;
    margin-right: 20px;
    &:focus, &:hover{
      background: #FFF;
      border: 1px solid #DCDFE6;
      color: #606266;
    }
  }
  .el-button:last-child{
    margin-right: 0;
    color: #FFF;
    background-color: #409EFF;
  }
  .input{
    .el-input__inner {
      width: 300px;
    }
  }
  .el-pagination{
    margin: 20px 0 0;
    /* display: flex;
    justify-content: space-around; */
  }
}
</style>

